'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Constants


var _reactRedux = require('react-redux');

var _measurementsConstants = require('./measurementsConstants');

exports.default = function () {
    var opts = _extends({}, arguments.length <= 3 ? undefined : arguments[3], {
        storeKey: _measurementsConstants.MEASUREMENTS_STORE_NAME,
        getDisplayName: function getDisplayName(component) {
            return 'MeasurementsConnect(' + component + ')';
        }
    });
    return (0, _reactRedux.connect)(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2], opts);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/measurementsConnect.js
// module id = 123
// module chunks = 0